<div class="card">
  <div class="card-body">
    <h5 class="card-title">QC Completed Report</h5>
    <div class="description">
      Export the list of abstracts that were fully QC Coded between the selected date range. Optionally choose to include how
      each abstract was coded.
    </div>
    <form [formGroup]="coderForm" (ngSubmit)="onSubmit()">
      <div class="mt-3">
        <div class="d-inline-block mr-3">
          <mat-form-field>
            <input matInput [matDatepicker]="pickerFrom" formControlName="startDate" placeholder="Start Date">
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <mat-error *ngIf="coderForm.get('startDate').hasError('required')">End date is required.</mat-error>
          </mat-form-field>
        </div>
        <div class="d-inline-block mr-3">
          <mat-form-field>
            <input matInput [matDatepickerFilter]="endDateFilter" [matDatepicker]="pickerTo" formControlName="endDate" placeholder="End Date">
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <mat-error *ngIf="coderForm.get('endDate').hasError('required')">End date is required.</mat-error>
            <mat-error *ngIf="coderForm.get('endDate').hasError('matDatepickerFilter')">End date cannot be earlier than start date.</mat-error>
          </mat-form-field>
        </div>
        <div class="d-inline-block">
          Include Coding Results:
          <mat-form-field class="report-select">
            <mat-select formControlName="phase">
              @for(type of reportTypes; track type){
              <mat-option [value]="type">
                {{ type.description }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <button mat-button class="btn my-3" [ngClass]="coderForm.valid ? 'btn-success' : 'btn-danger'">Run Report</button>
    </form>
  </div>
</div>
